/**
 * 投诉相关API接口
 * 实现投诉提交、附件上传等功能
 */

import { req } from '../utils/request'

export class Complaint {
  /**
   * 提交投诉
   * @param {Object} data - { complained_id, title, content, attachments, address }
   * @returns {Promise}
   */
  submitComplaint(data) {
    return req.post('user.complaint/submit', data)
  }
  
  /**
   * 上传投诉附件
   * @param {File} file - 文件对象
   * @returns {Promise}
   */
  uploadAttachment(file) {
    const formData = new FormData()
    formData.append('file', file)
    return req.post('user.complaint/upload', formData, 'file')
  }
  
  /**
   * 获取可投诉的会员列表（协会注册的机构或个人）
   * @param {Object} params - { member_type, keyword }
   * @returns {Promise}
   */
  getComplainableMembers(params) {
    return req.get('user.complaint/complainableMembers', params)
  }
}

export default new Complaint()
